import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { CLIENT_DETAIL, CLIENT_DETAILS, LOGIN_USER, LOGOUT_USER, USER_DETAIL } from "./actionTypes"
import { loginSuccess, apiError, getUserDetailSuccess, getUserDetailFail, getClientDetailsSuccess, getClientDetailsFail } from "./actions"
import { toast } from "react-toastify";
import {
  getClientDetailApi,
  getLocalDataApi,
  getUserDetailApi,
  postLogin
} from "../../../helpers/backend_helper"
import { getLocalDataSuccess } from "store/actions";

function* loginUser({ payload: { user, history } }) {
  try {
    //toast.dismiss();
      toast.loading("Please wait...")
      const response = yield call(postLogin, {
        userName: user.email,
        password: user.password,
        userType:'Client',
        portal:"Client"
      })
       
        const data = JSON.stringify(response)
        const dparse = JSON.parse(data);
    
        //localStorage.setItem("token",dparse.resultData.bearerToken);
        localStorage.setItem("userId",dparse.resultData.uId);
        localStorage.setItem("clientGuid",dparse.resultData.createdBy);
        localStorage.setItem("agentId",dparse.resultData.createdBy);
        //localStorage.setItem("tokenExpiry",dparse.resultData.accessTokenExpiration);
        localStorage.setItem("authUser", data)
        sessionStorage.setItem("activeSession", "true")
        yield put(loginSuccess(response))
        //const resdata = [];
        const resdata = yield call(getLocalDataApi);
        const newresdata = {}
        for (var i = 0, loc; i < resdata.length; i++) {
        loc = resdata[i];
        newresdata[ loc.localizationResourceKey] = loc.localizationResourceValue;
        }
        
        localStorage.setItem("localData",JSON.stringify(newresdata))
        //console.log(JSON.stringify(newresdata))
        //yield put(getLocalDataSuccess(resdata))
        history.push("/dashboard")
    }
catch (error) {
  toast.dismiss();

    yield put(apiError('Invalid User'))

  
}
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("userId")
    localStorage.removeItem("agentId")
    localStorage.removeItem("clientGuid")
    localStorage.removeItem("localData")
    sessionStorage.removeItem("activeSession")
    // Cookies will be cleared by server on logout endpoint
    history.push("/login")
  } catch (error) {
    yield put(apiError(""))
  }
}

function* fetchUserDetail({ agentId, clientId }) {
  try {
    const response = yield call(getUserDetailApi, agentId, clientId)
    yield put(getUserDetailSuccess(response))
  } catch (error) {
    yield put(getUserDetailFail(error))
  }
}


function* fetchClientDetails({ clientId }) {
  try {
    const response = yield call(getClientDetailApi, clientId)
    yield put(getClientDetailsSuccess(response))
  } catch (error) {
    yield put(getClientDetailsFail(error))
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(USER_DETAIL, fetchUserDetail)
  yield takeEvery(CLIENT_DETAILS, fetchClientDetails)
}

export default authSaga
